module.exports = __webpack_public_path__ + "img/TU4_Header_White.cf4ac476.png";